import { render, staticRenderFns } from "./SpclClsf.vue?vue&type=template&id=034ed7ac&scoped=true"
import script from "./SpclClsf.vue?vue&type=script&lang=js"
export * from "./SpclClsf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034ed7ac",
  null
  
)

export default component.exports